import { clsx } from 'clsx';
import * as styles from '../styles.css';
import { Props } from 'recharts/types/component/DefaultLegendContent';

export const customLegend = (props: Props) => {
  const { payload } = props;

  return (
    <div className={styles['legend']}>
      <ul>
        {payload?.map((item, index) => (
          <li key={index}>
            <div className={styles['pin']} style={{ backgroundColor: item.color }} />
            <span>{item.value}</span>
          </li>
        ))}
        <li>
          <div className={clsx(styles['pin'], styles['custom-pin'])} />
          <span>Было активно продвижение</span>
        </li>
      </ul>
    </div>
  );
};
